import React, {Component} from 'react'
import propTypes from 'prop-types'
import Files from '../../../api/Files'
import moment from 'moment'
import {strVal} from '../../../modules/Utils'
import Documents from './Documents'
import {get, isEmpty, pick} from 'lodash'
import DocumentsWidget from '../../../components/Common/Documents/DocumentsWidget'

class DocumentsCont extends Component {
  constructor(props) {
    super(props)
    this.api = new Files()
    this.owner = props.owner
    this.upload = props.upload
    this.state = {
      files: [],
      list: [],
      fetching: false,
      visible: false,
      fullListVisible: false,
      file: {},
      type: '',
    }
    this.isWidget = props.isWidget
  }

  showModal = () => {
    this.setState({
      visible: true,
      type: 'new',
      file: {_key: moment().unix()},
    })
  }

  showFullListModal = () => {
    this.setState({fullListVisible: true})
  }

  handleCancel = async updated => {
    this.setState({
      visible: false,
      file: {},
    })
    if (updated === true) await this.fetch()
  }

  fullListHandleCancel = () => {
    this.setState({fullListVisible: false})
  }

  fetch = async () => {
    this.setState({fetching: true})
    let files = await this.api.listMulti(this.owner)
    this.setState({files, list: files, fetching: false})
  }

  componentDidMount = async () => {
    if (
      this.props.owner._id ||
      (Array.isArray(this.props.owner) && this.props.owner.length > 0)
    ) {
      await this.fetch()
    }
  }

  async componentWillReceiveProps(nextProps, nextContext) {
    if (
      !isEmpty(get(nextProps, 'owner._id')) &&
      this.owner._id !== get(nextProps, 'owner._id')
    ) {
      this.owner = nextProps.owner
      await this.fetch()
    }
    if (Array.isArray(this.owner) && this.owner.length > 0) await this.fetch()
  }

  handleOnRowClick = record => {
    this.setState({file: record, visible: true, type: 'edit'})
  }
  search = e => {
    let filtered = this.state.files
      .map(a => a)
      .filter(row => {
        return (
          strVal(row, 'name')
            .toUpperCase()
            .includes(e.target.value.toUpperCase()) ||
          strVal(row, 'file')
            .toUpperCase()
            .includes(e.target.value.toUpperCase()) ||
          strVal(row, 'category')
            .toUpperCase()
            .includes(e.target.value.toUpperCase())
        )
      })
    this.setState({list: filtered})
  }

  render() {
    return this.isWidget ? (
      <DocumentsWidget
        {...this.state}
        {...this.props}
        {...pick(this, [
          'showModal',
          'handleCancel',
          'fetch',
          'showFullListModal',
          'fullListHandleCancel',
          'handleOnRowClick',
        ])}
      />
    ) : (
      <Documents
        {...this.state}
        {...this.props}
        {...pick(this, [
          'showModal',
          'handleCancel',
          'fetch',
          'handleOnRowClick',
          'search',
        ])}
      />
    )
  }
}

DocumentsCont.propTypes = {
  owner: propTypes.object.isRequired,
  footer: propTypes.bool,
  editable: propTypes.bool,
  category: propTypes.bool,
  email: propTypes.bool,
}
DocumentsCont.defaultProps = {
  footer: false,
  owner: {},
  email: false,
  emailLabel: 'Email',
  editable: true,
  category: true,
}
export default DocumentsCont
